module.exports = __webpack_public_path__ + "static/media/personsm.65888868.svg";